function main() {
    const carouselSelectionImages = Array.from(document.querySelectorAll('.carousel-selection-img'));
    const carouselActiveImages = Array.from(document.querySelectorAll('.type-showcase-carousel-img'));

    if (carouselSelectionImages.length > 0) {
        carouselSelectionImages.forEach(img => {
            img.addEventListener('click', () => {
                const id = img.id;
                for (const imgContainer of carouselActiveImages) {
                    if (imgContainer.getAttribute('data-img-id') === id) {
                        imgContainer.classList.add('active');
                    } else {
                        imgContainer.classList.remove('active');
                    }
                }
            });
        });
    }
}
main();